export default __webpack_public_path__ + "static/media/Snowing_03.9e5d196d.png";